import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Backdrop, CircularProgress } from '@mui/material'

export function BackdropProgress() {
  const classes = useStyles()

  return (
    <Backdrop className={classes.backdrop} open>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    backdrop: {
      zIndex: 1,
      backgroundColor: '#e0e0e0',
    },
  }
})
